export const DEFAULT_COLLECTION_COVER_IMAGE = '/course-banner.jpg'

export const POLICY_LANG_CONFIG = {
  en: '13152455',
  it: '36132119',
}

export const COLLECTION_COMPLETED_INTRODUCTION_DATE = '2024-11-04'

export const CONTENT_COMPLETED_INTRODUCTION_DATE = '2024-11-26'

export const INTL_DATE_FORMAT_OPTIONS = {
  day: '2-digit' as const,
  month: '2-digit' as const,
  year: 'numeric' as const,
}

export const AUTHENTICATION_PROVIDERS = ['google', 'linkedin']

export const AUTHENTICATION_PROVIDERS_ICON_PATH = {
  google: '/icon-google.svg',
  linkedin: '/icon-linkedin.svg',
}

export const PDF_CONTENT_SCROLL_NAVIGATION_PAGES_THRESHOLD = 90

// breakpoints are based on Tailwind CSS
// https://tailwindcss.com/docs/breakpoints
export const BREAKPOINTS = {
  default: 4,
  1024: 3, // lg
  768: 2, // md
  475: 1, // xs
}

export const MAX_TAGS = 50

export const DEFAULT_SELLING_PRICING_FOR_DECIMAL_CURRENCY = 1
export const DEFAULT_SELLING_PRICING_FOR_JPY = 100
